<template>
    <div class="skill-score">
        <Navbar />
        <div class="mt-5 pt-5 kovatek-width-1">
            <div class="mx-lg-4 pl-xl-2 pr-xl-4">
                <div
                    class="alert bg-kovatek alert-dismissible fade show mx-3 mx-md-5 px-0 px-md-3"
                    v-if="!loading && profileData"
                >
                    <button type="button" class="close text-white pt-sm-3 mt-1" data-dismiss="alert">
                        &times;
                    </button>
                    <h4 class="font-weight-bolder my-1 text-white note-text ml-n3 ml-md-n0">
                        Complete your vetting exercise
                    </h4>
                </div>
            </div>
            <div class="container-fluid">
                <div class="row mt-md-4 mx-md-3 mx-lg-5">
                    <div class="col-md-12 col-xl-8">
                        <div class="row">
                            <div v-if="!loading && profileData" class="col-md-8">
                                <div class="d-md-flex">
                                    <div class="mr-md-3 text-center">
                                        <img :src="profileImage" class="rounded-circle img-height my-2" />
                                        <h4 class="kova-text mt-md-1">{{ data.Username }}</h4>
                                    </div>
                                    <div class="py-md-3 text-center text-md-left">
                                        <h3 class="font-weight-bolder kova-text ctrl-heading mb-0" v-if="profileTitle">
                                            {{ profileTitle }}
                                            <img
                                                class="mb-1"
                                                style="height:22px;"
                                                src="../assets/kovatek/correct.svg"
                                                alt=""
                                            />
                                            <font-awesome-icon
                                                :icon="['fab', 'user-check']"
                                                class="user-check-col ml-2"
                                            ></font-awesome-icon>
                                        </h3>
                                        <!-- <h5 class="text-left mb-1 ctrl-heading1">
                      {{ profileData.Title }}
                    </h5> -->
                                        <h6 class="text-uppercase mb-0 mb-md-1 text-intermediate ctrl-heading2">
                                            {{ profileLevel }}
                                        </h6>

                                        <div class="mt-md-2">
                                            <span class="text-size2 font-weight-bolder" v-if="profileData.WorkRate">
                                                {{ workrate }} </span
                                            >/hr
                                            <p class="text-size2">
                                                <font-awesome-icon
                                                    style="font-size: 20px;"
                                                    icon="map-marker-alt"
                                                    class="text-dark mr-2"
                                                ></font-awesome-icon>
                                                {{ profileData.City }}, {{ profileData.Country }}
                                            </p>
                                        </div>
                                        <div class="d-none d-md-block">
                                            <router-link to="/devsignup/overview">
                                                <font-awesome-icon
                                                    icon="pen"
                                                    class="text-dark mr-2 pen-icon"
                                                    style="font-size: 16px"
                                                ></font-awesome-icon>
                                                Update
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-12" v-else>
                                <a-skeleton active avatar :paragraph="{ rows: 3 }" />
                            </div>

                            <div v-if="!loading && profileData" class="col-md-4 text-center text-md-right">
                                <span class=""
                                    ><img class="mr-3 star" src="../assets/kovatek/best.svg" alt="" /><span
                                        class="font-weight-bolder text-size rating"
                                        >{{ profileData.SkillScore || '0.0' }}</span
                                    >
                                </span>
                                <p class="ml-md-2 ctrl-size-2">{{ profileData.Reviews }} reviews</p>
                                <p class="mb-0 ctrl-heading1">Jobs Completed: {{ completedJobs.length }}</p>
                                <p class="mb-0 ctrl-heading1">
                                    Team work: 0
                                </p>

                                <div class="mt-2 d-none d-md-block">
                                    <button class="programming-task px-4 px-4 py-2 text-size2">
                                        Apply for Workspace
                                    </button>
                                </div>

                                <div class="mt-3 d-flex justify-content-between d-md-none">
                                    <router-link to="/devsignup/overview" class="mt-2">
                                        <font-awesome-icon
                                            icon="pen"
                                            class="text-dark mr-2 pen-icon"
                                            style="font-size: 16px"
                                        ></font-awesome-icon>
                                        Update
                                    </router-link>

                                    <button class="programming-task px-4 px-4 py-2 text-size2">
                                        Apply for Workspace
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4 d-none d-xl-block">
                        <div class="w-100" style="max-width: 415px;" :style="[!loading && { position: 'fixed' }]">
                            <Notifications class="px-3 px-sm-4 px-md-3 px-lg-4" v-if="!loading && profileData" />
                            <div class="bg-light p-2 border add-rounded shadow-sm mb-5 ml-3 mr-3" v-else>
                                <a-skeleton active :paragraph="{ rows: 3 }" />
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!loading && profileData" class="px-md-3 mx-md-4 mx-lg-5 mt-5">
                    <div class="row">
                        <div class="col-12 col-xl-8 pb-5">
                            <template v-if="talentEducation.length">
                                <h4 class="font-weight-bolder text-left">Education</h4>
                                <div class="row" v-for="education in talentEducation" :key="education.ID + 'z'">
                                    <div class="col-6">
                                        <h6 class="font-weight-bolder text-left kova-text mb-0">
                                            {{ education.Institution }}
                                        </h6>
                                        <p class="text-left text-capitalize">
                                            {{ education.Location }}
                                        </p>
                                    </div>
                                    <div class="col-6">
                                        <h6 class="font-weight-bolder text-right mb-0 text-capitalize">
                                            {{ education.Course }}
                                        </h6>
                                        <p class="text-right text-capitalize">
                                            {{ education.From }} - {{ education.To }}
                                        </p>
                                    </div>
                                </div>
                            </template>

                            <template v-if="talentCompanies.length">
                                <h4 class="font-weight-bolder text-left mt-3">Work Experience</h4>
                                <div class="row" v-for="company in talentCompanies" :key="company.ID + 'tslent'">
                                    <div class="col-6">
                                        <h6 class="font-weight-bolder text-left kova-text mb-0">
                                            {{ company.Organization }}
                                        </h6>
                                        <p class="text-left text-capitalize">
                                            {{ company.Location }}
                                        </p>
                                    </div>
                                    <div class="col-6">
                                        <h6 class="font-weight-bolder text-right mb-0">
                                            {{ company.Role }}
                                        </h6>
                                        <p class="text-right text-capitalize">{{ company.From }} - {{ company.To }}</p>
                                    </div>
                                </div>
                            </template>

                            <div class="row mt-3">
                                <div class="col-3">
                                    <h4 class="font-weight-bolder text-left">Skill Score</h4>
                                </div>
                                <div class="col"></div>
                                <div class="col-3">
                                    <h4 class="font-weight-bolder text-right kova-text"></h4>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <h6 class="font-weight-bolder text-left kova-text">
                                        Profile
                                    </h6>
                                </div>
                                <div class="col"></div>
                                <div class="col-3">
                                    <h6 class="font-weight-bolder text-right kova-text"></h6>
                                </div>
                            </div>
                            <div class="row" :key="i" v-for="(profile, i) in profileScore">
                                <div class="col-8">
                                    <p class="text-left">- {{ profile.title }}</p>
                                </div>
                                <div class="col"></div>
                                <div class="col-2 d-flex justify-content-end">
                                    <div class="score">{{ profile.score || '-' }}</div>
                                </div>
                            </div>

                            <div class="row mt-3">
                                <div class="col-6">
                                    <h6 class="font-weight-bolder text-left kova-text">
                                        Skills Assessment
                                    </h6>
                                </div>
                                <div class="col"></div>
                                <div class="col-3">
                                    <h6 class="font-weight-bolder text-right kova-text"></h6>
                                </div>
                            </div>

                            <div class="row" :key="i + 'sss'" v-for="(skill, i) in skillScore">
                                <div class="col-5 col-sm-4 col-md-3 d-flex">
                                    <img class="mr-2" height="22" :src="getSkillImg(skill.title)" />
                                    <p class="text-left">{{ skill.title }}</p>
                                </div>
                                <div class="col">
                                    <a-progress :percent="skill.progress" strokeColor="#4BB38E" />
                                </div>
                                <div class="col-2 d-flex justify-content-end">
                                    <div class="score">{{ skill.score || '-' }}</div>
                                </div>
                            </div>

                            <!-- Sprint Exercise Stats -->
                            <div class="row mt-3 d-none">
                                <div class="col-6">
                                    <h6 class="font-weight-bolder text-left kova-text">
                                        Sprint Project Exercise
                                    </h6>
                                </div>
                                <div class="col"></div>
                                <div class="col-3">
                                    <h6 class="font-weight-bolder text-right kova-text"></h6>
                                </div>
                            </div>
                            <div class="row d-none" :key="i + 'a'" v-for="(sprint, i) in sprintScore">
                                <div class="col-5 col-sm-4 col-md-3">
                                    <p class="text-left">- {{ sprint.title }}</p>
                                </div>
                                <div class="col">
                                    <a-progress :percent="sprint.progress" strokeColor="#4BB38E" />
                                </div>
                                <div class="col-2 d-flex justify-content-end">
                                    <div class="score">{{ sprint.score || '-' }}</div>
                                </div>
                            </div>

                            <!-- Live Interview Stats -->
                            <div class="row mt-3 d-none">
                                <div class="col-6">
                                    <h6 class="font-weight-bolder text-left kova-text">
                                        Live Interview
                                    </h6>
                                </div>
                                <div class="col"></div>
                                <div class="col-3">
                                    <h6 class="font-weight-bolder text-right kova-text"></h6>
                                </div>
                            </div>
                            <div class="row d-none" :key="i + 'b'" v-for="(interview, i) in interviewScore">
                                <div class="col-8">
                                    <p class="text-left">- {{ interview.title }}</p>
                                </div>
                                <div class="col"></div>
                                <div class="col-2 d-flex justify-content-end">
                                    <div class="score">{{ interview.score || '-' }}</div>
                                </div>
                            </div>

                            <div class="my-3 my-lg-4"></div>
                            <hr />

                            <!-- Skills Stats -->
                            <h4 class="font-weight-bolder text-left mt-4">Skills Assessment</h4>
                            <a-alert
                                message="The time limit for the skills assessment exercise has expired"
                                banner
                                class="w-100 mb-3"
                                closable
                                v-if="testExpired"
                            />
                            <div class="row sprint-project" v-if="!testDone">
                                <template v-if="testRequested">
                                    <div class="col-md-5 col-sm-12 text-left px-0 px-sm-3 ml-3 ml-md-0">
                                        <div>
                                            <button
                                                class="py-2 px-2 px-4 font-weight-bolder request btn-kovatek"
                                                @click="$router.push('/tests')"
                                            >
                                                Continue Test
                                            </button>
                                        </div>
                                    </div>

                                    <div class="col-md-7 col-sm-12 px-0">
                                        <countdown
                                            class="countdown"
                                            :deadline="testDeadline"
                                            @timeElapsed="testCountdownOver"
                                            :showDays="false"
                                        ></countdown>
                                    </div>
                                </template>
                                <div class="col-12 px-0 px-sm-3 text-left ml-3 ml-md-0" v-else>
                                    <button
                                        class="py-2 px-4 px-lg-5 font-weight-bolder request btn-kovatek"
                                        @click="testModal = true"
                                    >
                                        Request
                                    </button>
                                </div>
                            </div>
                            <div class="text-left" v-else>
                                <div class="d-flex" v-if="testPassed">
                                    <img style="height:20px;" src="../assets/kovatek/correct.svg" alt="" />
                                    <h6 class="font-weight-bolder ml-1">
                                        You have completed the Skills Assessment Exercise
                                        <br />
                                        as you attained the minimum required test score
                                    </h6>
                                </div>
                                <template v-else>
                                    <div class="d-flex">
                                        <img style="height:20px;" src="../assets/kovatek/failed.jpg" alt="" />
                                        <h6 class="font-weight-bolder ml-1">
                                            You have failed the Skills Assessment Exercise
                                            <br />
                                            as you did not attain the minimum required test score
                                        </h6>
                                    </div>
                                    <h6 class="ml-3 pl-2">
                                        You can redo the test in 2 weeks
                                    </h6>
                                </template>
                            </div>

                            <div class="my-3 my-lg-4"></div>
                            <hr />
                            <h4 class="font-weight-bolder text-left mt-4">Sprint Project Exercise (Coming Soon)</h4>
                            <a-alert
                                message="The time limit for the sprint project exercise has expired"
                                banner
                                class="w-75 mb-3"
                                closable
                                v-if="sprintExpired"
                            />
                            <div class="d-none">
                                <div class="row sprint-project" v-if="!sprintProjectDone">
                                    <div
                                        class="col-md-5 col-sm-12 text-left px-0 px-sm-3 ml-3 ml-md-0"
                                        v-if="sprintProjectRequest"
                                    >
                                        <div class="w-75">
                                            <button
                                                class="py-2 px-4 mb-3 mb-3 px-lg-5 font-weight-bolder request btn-kovatek"
                                                @click="viewSprintProject = true"
                                            >
                                                View Exercise
                                            </button>
                                        </div>
                                        <div>
                                            <button
                                                class="py-2 px-2 px-md-4 px-lg-5 font-weight-bolder messaging"
                                                style="border-radius: 10px"
                                                @click="sprintSubmit = true"
                                            >
                                                Submit Project
                                            </button>
                                        </div>
                                    </div>

                                    <div class="col-md-7 col-sm-12 px-0" v-if="sprintProjectRequest && sprintDeadline">
                                        <countdown
                                            class="countdown"
                                            :deadline="sprintDeadline"
                                            @timeElapsed="sprintCountdownOver"
                                            :showDays="false"
                                        ></countdown>
                                    </div>

                                    <div class="col-12 px-0 px-sm-3 text-left ml-3 ml-md-0" v-else>
                                        <button
                                            class="py-2 px-2 px-md-4 px-lg-5 font-weight-bolder request btn-kovatek"
                                            @click="sprintModal = true"
                                        >
                                            Request Project
                                        </button>
                                    </div>
                                </div>
                                <div class="text-left d-flex ml-3 ml-md-0" v-else>
                                    <img style="height:22px;" src="../assets/kovatek/correct.svg" alt="" />
                                    <h6 class="font-weight-bolder ml-2">
                                        You have completed the Sprint Project Exercise
                                    </h6>
                                </div>

                                <div class="my-3 my-lg-4"></div>
                            </div>
                            <hr />

                            <h4 class="font-weight-bolder text-left mt-4">Live Interview (Coming Soon)</h4>
                            <div class="row mb-4 d-none">
                                <div class="col-sm-12 col-md-6 text-left" v-if="!interviewHasBeenScheduled">
                                    <a-alert
                                        message="You missed your interview, please re-schedule another interview"
                                        banner
                                        class="w-75 mb-3"
                                        closable
                                        v-if="missedInterview"
                                    />
                                    <button
                                        class="py-2 px-2 px-md-4 px-lg-5 font-weight-bolder request btn-kovatek"
                                        @click="interviewModal = true"
                                    >
                                        Schedule Interview
                                    </button>
                                </div>

                                <div class="col-sm-12 col-md-8 mt-3 pl-3 text-left" v-else>
                                    <p>
                                        Your live interview is scheduled on the date and time below. Please endeavour to
                                        be early
                                    </p>
                                    <h5 class="font-weight-bolder my-2">
                                        <span class="bg-light px-2 py-2 rounded font-weight-bolder">
                                            {{ interviewDate | moment }}
                                        </span>
                                    </h5>

                                    <div class="mt-3 mt-md-4">
                                        <a-tooltip placement="topLeft">
                                            <template slot="title">
                                                <span>
                                                    <a-icon
                                                        type="info-circle"
                                                        style="position:relative; bottom: 3px;font-size: 16px;"
                                                    />
                                                    {{ copied ? 'Copied to clipboard' : 'click to copy' }}
                                                </span>
                                            </template>
                                            <span
                                                @mouseover="copied = false"
                                                @click="copy('')"
                                                class="kova-id px-3 py-2 text-white font-weight-bolder"
                                                >Call ID: Kovatek.id.2245</span
                                            >
                                        </a-tooltip>
                                    </div>

                                    <div
                                        :style="{
                                            width: '300px',
                                            border: '1px solid #d9d9d9',
                                            borderRadius: '4px',
                                        }"
                                        class="mt-3"
                                    >
                                        <a-calendar
                                            class="interview-selected"
                                            :value="calendarDate"
                                            :disabled="true"
                                            :fullscreen="false"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-else class="px-md-3 mx-md-4 mx-lg-5 mt-5 mt-md-3">
                    <div class="row">
                        <div class="col-12 col-lg-9">
                            <h4 class="font-weight-bolder text-left">Education</h4>
                            <a-skeleton active :paragraph="{ rows: 3 }" />

                            <h4 class="font-weight-bolder text-left">Work Experience</h4>
                            <a-skeleton active :paragraph="{ rows: 3 }" />

                            <h4 class="font-weight-bolder text-left">Skill Score</h4>
                            <a-skeleton active :paragraph="{ rows: 3 }" />

                            <div class="my-3 my-lg-4"></div>
                            <hr />

                            <h4 class="font-weight-bolder text-left mt-4">Sprint Project</h4>
                            <a-skeleton active :paragraph="{ rows: 3 }" />

                            <div class="my-3 my-lg-4"></div>
                            <hr />

                            <h4 class="font-weight-bolder text-left mt-4">Live Interview</h4>
                            <a-skeleton active :paragraph="{ rows: 3 }" />
                        </div>
                    </div>
                </div>

                <!-- Request Sprint Project -->
                <StartExercise
                    v-if="!sprintProjectRequest"
                    :visible.sync="sprintModal"
                    :profile="{
                        skills,
                        name: `${profileTitle} Sprint Test`,
                        complexity: profileData.WorkRate,
                    }"
                    :key="startKey"
                    @done="getOngoingSprint"
                />

                <pick-test
                    :visible.sync="testModal"
                    :profile="{
                        skills,
                        name: `${profileTitle} Sprint Test`,
                        complexity: profileData.WorkRate,
                    }"
                    :key="testKey"
                    @done="getOngoingTest"
                />

                <!-- Submit Sprint Project -->
                <SubmitExercise
                    :visible.sync="sprintSubmit"
                    :test="test"
                    @close="sprintSubmit = false"
                    @done="submitSprintProject"
                />

                <!-- call interview -->
                <CallScheduled :visible="callScheduled" @close="callScheduled = false" />
                <!-- <a-button
          style="background-color:#20409a; color: #fff"
          @click="callScheduled = true"
        >
          Ok
        </a-button> -->

                <ViewExercise
                    :visible="viewSprintProject"
                    @close="viewSprintProject = false"
                    :question="sprintQuestion"
                    :test="sprintTest"
                />

                <!-- interview schedule -->
                <ScheduleInterview
                    @showInterviewScheduled="
                        interviewModal = false;
                        interviewScheduled = true;
                    "
                    :visible="interviewModal"
                    v-if="interviewModal"
                    :profileData="profileData"
                    @done="interviewScheduleDone"
                    @close="interviewModal = false"
                />

                <ScheduledCall @close="callScheduled = false" :visible="callScheduled" />

                <interview-scheduled-modal
                    :visible="interviewScheduled"
                    @close="interviewScheduled = false"
                ></interview-scheduled-modal>
            </div>
        </div>
        <!-- <Footer /> -->
    </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
// import Footer from '@/components/Footer.vue'
import SubmitExercise from '../components/skillscore/SubmitExercise.vue';
import StartExercise from '../components/skillscore/StartExercise.vue';
import ScheduleInterview from '../components/skillscore/ScheduleInterview.vue';
import ScheduledCall from '../components/skillscore/ScheduledCall.vue';
import CallScheduled from '../components/skillscore/CallScheduled';
import interviewScheduledModal from '../components/skillscore/interviewScheduled.vue';
import Countdown from 'vue2-flip-countdown';
import ViewExercise from '../components/skillscore/ViewExercise.vue';
import Notifications from '../components/Notifications.vue';
import moment from 'moment-timezone';
import PickTest from '../components/mcq-test/PickTest.vue';

import { levels } from '../data/resources.js';

export default {
    name: 'skill-score',
    components: {
        Navbar,
        SubmitExercise,
        StartExercise,
        ScheduleInterview,
        CallScheduled,
        ScheduledCall,
        interviewScheduledModal,
        Countdown,
        ViewExercise,
        Notifications,
        PickTest,
        // Footer
    },
    async created() {
        this.$store.commit('setLoader', true);
        try {
            await Promise.all([this.getProfile(), this.getAllSettings(), this.getAllTests(), this.getInterviews()]);
        } catch (e) {
            const { message } = e;
            if (message.includes('Network'))
                this.showError('Network Error!', 'Please check your internet connection and try again');
        }
        this.$store.commit('setLoader', false);
    },
    computed: {
        workrate() {
            if (this.data.HourRate && !this.$route.path.includes('settings')) {
                return `Hourly Rate: $${this.data.HourRate}`;
            }

            return levels.find(key => key.id == this.profileData.WorkRate)?.work_rate;
        },
        sprintQuestion() {
            const { Questions } = this.sprintTest;
            if (!Questions) return {};
            return Questions[0];
        },
        talentEducation() {
            return this.profileData.Educations || [];
        },
        talentCompanies() {
            return this.profileData.Companies || [];
        },
        interviewDate() {
            return this.interview.Start || Date.now();
        },
        calendarDate() {
            return moment(this.interviewDate);
        },
        skills() {
            const { OtherCoreTechstacks, CoreTechstack } = this.profileData;

            if (CoreTechstack && CoreTechstack.includes(',')) {
                const core_techstack = (CoreTechstack || []).split(',').filter(key => key.length);

                return [...new Set([...core_techstack, ...(OtherCoreTechstacks || [])])];
            }

            return [CoreTechstack, ...(OtherCoreTechstacks || [])];
        },
        skillScore() {
            return this.skills.map(key => ({ title: key, progress: 0, score: 0 }));
        },
        testPassed() {
            const { Score, Questions } = this.test;
            return (Score / Questions.length) * 100 >= 80;
        },
    },
    data() {
        return {
            sprintProjectDone: false,
            sprintProjectRequest: false,
            submitted: false,
            profileScore: [],
            profileData: {},
            sprintScore: [
                { title: 'Code Quality', progress: 0, score: 0 },
                { title: 'Time Management', progress: 0, score: 0 },
                { title: 'Algorithms', progress: 0, score: 0 },
                { title: 'Debugging', progress: 0, score: 0 },
                { title: 'Data Structure', progress: 0, score: 0 },
            ],
            interviewScore: [
                { title: 'Communication', score: 0 },
                { title: 'Algorithm', score: 0 },
                { title: 'Problem Solving', score: 0 },
                { title: 'Professionalism', score: 0 },
                { title: 'API', score: 0 },
            ],
            data: {},
            loading: true,
            visible: false,
            callScheduled: false,
            interviewModal: false,
            interviewScheduled: false,
            interviewHasBeenScheduled: false,
            viewSprintProject: false,
            testDone: false,
            sprintModal: false,
            sprintSubmit: false,
            startKey: 2,
            submitKey: 29,
            test: {},
            sprintTest: {
                Questions: [],
            },
            testExpired: false,
            sprintExpired: false,
            missedInterview: false,
            interview: {},
            testRequested: false,
            testModal: false,
            testKey: 232,
            sprintDeadline: null,
            testDeadline: null,
        };
    },
    methods: {
        async getOngoingSprint(data) {
            this.$store.commit('setLoader', true);
            console.log(data);
            this.sprintModal = this.sprintProjectRequest = false;
            await this.getAllTests();
            this.$store.commit('setLoader', false);
        },
        async getOngoingTest() {
            this.$store.commit('setLoader', true);
            this.testKey += 1;
            this.testModal = false;
            await this.getAllTests();
            this.$store.commit('setLoader', false);
            this.$router.push('/tests');
        },
        async submitSprintProject() {
            this.$store.commit('setLoader', true);
            this.submitKey += 1;
            this.sprintSubmit = false;
            await this.getAllTests();
            this.$store.commit('setLoader', false);
        },
        async getTest(id) {
            const token = localStorage.getItem('token');
            try {
                const res = await this.$api({
                    url: `/tests/${id}`,
                    method: 'get',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                this.$store.commit('setLoader', false);
                console.log(res.data);
            } catch (err) {
                this.loading = false;
                this.catchErrors(err);
                // console.log(err)
            }
        },
        async getAllTests() {
            const token = localStorage.getItem('token');

            try {
                const res = await this.$api({
                    url: `/tests`,
                    method: 'get',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                const availableTests = res.data
                    .filter(key => key.Locked == false)
                    .sort((a, b) => new Date(b.CreatedAt).getTime() - new Date(a.CreatedAt).getTime());

                if (!availableTests.length) return null;
                const mcqTests = availableTests.filter(key => !key.Name.toLowerCase().includes('sprint'));
                const sprintTests = availableTests.filter(key => key.Name.toLowerCase().includes('sprint'));

                if (mcqTests.length) this.filterMCQTests(mcqTests);
                if (sprintTests.length) this.filterSprints(sprintTests);
            } catch (err) {
                if (!err.response) throw new Error('Network Error!');
                this.catchErrors(err);
                this.loading = false;
            }
        },
        filterSprints(tests) {
            const test = tests[0];
            // check if test duration has elasped
            const endTime = this.addMinutes(test.CreatedAt, 4320);

            if (this.dateHasPassed(endTime)) {
                const oneDay = new Date().getTime() + 3 * 24 * 60 * 60 * 1000;
                if (oneDay > endTime) this.sprintExpired = true;
                this.sprintProjectRequest = false;
                return;
            }

            this.sprintDeadline = this.timeFormat(endTime);
            this.sprintModal = false;
            this.sprintTest = test;
            this.sprintProjectRequest = true;

            return test;
        },
        filterMCQTests(tests) {
            const test = tests[0];

            // test is done
            if (test.Result === 0) {
                this.test = test;
                this.testDone = true;
                return;
            }

            // check if test duration has elasped
            const endTime = this.addMinutes(test.CreatedAt, 90);
            const testDeadline = this.timeFormat(endTime);
            const timeExpired = this.dateHasPassed(testDeadline);

            if (timeExpired) {
                const oneDay = new Date().getTime() + 1 * 24 * 60 * 60 * 1000;
                const hoursDiff = new Date(oneDay - endTime).getHours();

                if (hoursDiff > 24) this.testExpired = true;
                this.testRequested = false;
                return;
            }

            this.testDeadline = testDeadline;
            this.testModal = false;

            this.test = test;
            this.testRequested = true;
            return test;
        },
        async interviewScheduleDone() {
            this.$store.commit('setLoader', true);
            await this.getInterviews();
            this.interviewHasBeenScheduled = true;
            this.interviewModal = false;
            this.$store.commit('setLoader', false);
        },
        async getInterviews() {
            const token = localStorage.getItem('token');
            try {
                const res = await this.$api({
                    url: `/interviews`,
                    method: 'get',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                const interviewDates = res.data;

                if (interviewDates.length) {
                    const sortedDates = interviewDates.sort((a, b) =>
                        new Date(b.Start).getTime() > new Date(a.Start).getTime() ? 1 : -1,
                    );

                    this.interview = sortedDates[0];
                    const missedInterview = moment().isAfter(moment(this.interview.Start));
                    this.interviewHasBeenScheduled = !missedInterview;
                    this.missedInterview = missedInterview;
                }
            } catch (err) {
                if (!err.response) throw new Error('Network Error!');
                this.loading = false;
                this.catchErrors(err);
            }
        },
        async testCountdownOver() {
            this.$store.commit('setLoader', true);
            await this.getAllTests();
            this.$store.commit('setLoader', false);
        },
        sprintCountdownOver(val) {
            console.log(val);
        },
        timeFormat: date =>
            new Date(date)
                .toISOString()
                .replace(/T/, ' ')
                .replace(/\..+/, ''),
    },
};
</script>

<style scoped>
.skill-score {
    overflow-x: hidden;
}

h3.kova-text,
h4.font-weight-bolder,
h4.note-text {
    font-size: 20px;
}

h5.ctrl-heading1 {
    font-size: 16px;
}

.bg-kovatek {
    background-color: #20409a;
}
.img-height {
    width: 120px;
    height: 120px;
}
.text-intermediate {
    color: #bdbd50;
}
.text-size {
    font-size: 2.5em;
}
.text-size1 {
    font-size: 16px;
}
.text-size2 {
    font-size: 14px;
}
.rating {
    color: #4bb38e;
}
.star {
    position: relative;
    bottom: 10px;
    height: 25px;
}
.programming-task {
    background-color: transparent;
    outline: 0;
    border: solid 2px #20409a;
    border-radius: 10px;
    color: #20409a;
    transition: 0.25s;
}
.programming-task:hover {
    background-color: #20409a;
    color: #fff;
}
.pen-icon {
    font-size: 22px;
}
.score {
    width: 25px;
    height: 20px;
    background-color: #4bb38e;
    border-radius: 5px;
    color: #fff;
}
.request {
    border-radius: 10px;
}
.messaging {
    background-color: #f1f1f1;
    color: #4f5052;
    transition: 0.25s;
    border: solid 1px #f1f1f1;
    outline: 0;
}
.messaging:hover {
    background-color: #d3d3d3;
    color: #4f5052;
}
.point {
    width: 20px;
    height: 20px;
    background-color: #20409a;
    border-radius: 50%;
}

.interview-selected >>> .ant-fullcalendar-header {
    display: none;
}

@media screen and (min-width: 992px) and (max-width: 1325px) {
}

@media screen and (min-width: 992px) and (max-width: 1200px) {
    .img-height {
        width: 120px;
        height: 120px;
    }
}

@media screen and (min-width: 768px) and (max-width: 991px) {
    .img-height {
        width: 120px;
        height: 120px;
    }
}

@media screen and (max-width: 767px) {
    .img-height {
        width: 115px;
        height: 115px;
    }
    .text-size {
        font-size: 1.8em;
    }
    .text-size2 {
        font-size: 16px;
    }
    .ctrl-heading {
        font-size: 1.4em;
    }
    .ctrl-heading1 {
        font-size: 1.2em;
    }
    .ctrl-heading2 {
        font-size: 0.9em;
    }
    .star {
        position: relative;
        bottom: 5px;
        height: 18px;
    }
}

@media screen and (max-width: 550px) {
    .text-size2 {
        font-size: 12px;
    }
    .img-height {
        width: 85px;
        height: 85px;
    }
    .pen-icon {
        font-size: 12px;
    }
    .note-text {
        font-size: 15px;
    }
}

.countdown {
    text-align: right !important;
}
</style>
